import React from 'react';
import './ErrorMessage.css';

interface ErrorMessageProps {
  error: string;
  onDismiss?: () => void;
  onRetry?: () => void;
  dismissText?: string;
  retryText?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  error,
  onDismiss,
  onRetry,
  dismissText = "Dismiss",
  retryText = "Retry"
}) => {
  return (
    <div className="error-message-container">
      <div className="error-message-content">
        <div className="error-icon">⚠️</div>
        <h3 className="error-title">Something went wrong</h3>
        <p className="error-text">{error}</p>

        <div className="error-actions">
          {onRetry && (
            <button
              className="error-button error-button-primary"
              onClick={onRetry}
            >
              {retryText}
            </button>
          )}
          {onDismiss && (
            <button
              className="error-button error-button-secondary"
              onClick={onDismiss}
            >
              {dismissText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
